import { render, staticRenderFns } from "./Fast_internet_home_G12.vue?vue&type=template&id=5c64ccce&scoped=true&"
import script from "./Fast_internet_home_G12.vue?vue&type=script&lang=js&"
export * from "./Fast_internet_home_G12.vue?vue&type=script&lang=js&"
import style0 from "./Fast_internet_home_G12.vue?vue&type=style&index=0&id=5c64ccce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64ccce",
  null
  
)

export default component.exports